import * as React from 'react';
import { KatAlert } from '@amzn/katal-react';
import { useTranslation } from 'react-i18next';
import StringBuilderWithLink from './utils/StringBuilderWithLink';

export const PageBanner = () => {
  const { t } = useTranslation('pnf_website_components');

  return (
    <KatAlert
      header={t('pnf_new_reporting_ui_alert_header')}
      id="pnf-new-reporting-ui-alert"
      persistent
      variant="info"
    >
      <StringBuilderWithLink
        linkProps={{
          href: '', // add link to help page
          target: '_blank',
        }}
        linkStrToReplace="pnf_new_reporting_ui_alert_link"
        strToBuild="pnf_new_reporting_ui_alert"
      />
    </KatAlert>
  );
};
